import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { FinanceCategoryFormValues } from "pages/FinanceCategories/FinanceCategoryForm/FinanceCategoryForm";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string = "",
  orderBy: string = "",
): AxiosPromise<BaseApiPaging<CourseFinanceCategoryApi>> => {
  return api.get<BaseApiPaging<CourseFinanceCategoryApi>>(
    endpoints.COURSE_FINANCE_CATEGORIES.GET(skip, take, searchPhrase, filter, orderBy),
  );
};

const fetchById = (id: number): AxiosPromise<CourseFinanceCategoryApi> => {
  return api.get<CourseFinanceCategoryApi>(endpoints.COURSE_FINANCE_CATEGORIES.GET_BY_ID(id));
};

const create = (data: FinanceCategoryFormValues): AxiosPromise<number> => {
  return api.post<number>(endpoints.COURSE_FINANCE_CATEGORIES.CREATE(), data);
};
const update = (id: number, data: FinanceCategoryFormValues): AxiosPromise<CourseFinanceCategoryApi> => {
  return api.put<CourseFinanceCategoryApi>(endpoints.COURSE_FINANCE_CATEGORIES.UPDATE(id), data);
};
const deleteCourse = (id: number): Promise<void> => {
  return api.delete(endpoints.COURSE_FINANCE_CATEGORIES.DELETE(id));
};
export const courseFinanceCategoriesApi = {
  fetch,
  fetchById,
  create,
  update,
  delete: deleteCourse,
};

export interface CourseFinanceCategoryApi {
  name: string;
  id: number;
  isSystem: boolean;
}
